import React, { useState, useEffect } from 'react';
import { Badge } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  IconHeart,
  IconShoppingCart,
  IconMessage,
  IconBell,
  IconRocket,
  IconBox
} from '@tabler/icons-react';
import { useWishlist } from '../WishlistContext';
import { useCart } from '../CartContext';
import UserServ from '../service/UserServ';
import NotificationServ from '../service/NotificationServ';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { wishlist, wishlistCount: contextWishlistCount } = useWishlist();
  const { cart, cartCount: contextCartCount, isDrawerOpen, setIsDrawerOpen } = useCart();
  const [unreadChatCount, setUnreadChatCount] = useState(0);
  const [unreadNotifCount, setUnreadNotifCount] = useState(0);

  // Reactive Auth State
  const [authState, setAuthState] = useState({
    role: localStorage.getItem('role')?.toLowerCase(),
    token: localStorage.getItem('token') || localStorage.getItem('customerToken')
  });

  const isAuthenticated = authState.token && authState.token !== "null" && authState.token !== "undefined";
  const role = authState.role;

  const wishlistCount = contextWishlistCount || wishlist?.products?.length || 0;
  const cartCount = contextCartCount || cart?.items?.length || 0;

  useEffect(() => {
    const syncAuth = () => {
      setAuthState({
        role: localStorage.getItem('role')?.toLowerCase(),
        token: localStorage.getItem('token') || localStorage.getItem('customerToken')
      });
    };

    window.addEventListener('storage', syncAuth);
    window.addEventListener('auth-change', syncAuth);
    return () => {
      window.removeEventListener('storage', syncAuth);
      window.removeEventListener('auth-change', syncAuth);
    };
  }, []);

  const fetchData = async () => {
    if (!isAuthenticated) return;
    try {
      // Chat counts
      // const chatRes = await UserServ.getUnreadCount();
      // if (chatRes && chatRes.data !== undefined) {
      //   setUnreadChatCount(chatRes.data);
      // }

      // Notification counts
      const notifRole = ['admin', 'superadmin'].includes(role) ? 'admin' : role === 'seller' ? 'seller' : 'user';
      const notifRes = await NotificationServ.getUnreadCount(notifRole);
      // if (notifRes && notifRes.data !== undefined) {
      //   setUnreadNotifCount(notifRes.data);
      // }
    } catch (error) {
      console.error("Failed to fetch counts for bottom nav", error);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 30000); // Refresh every 30s
    return () => clearInterval(interval);
  }, [role, isAuthenticated]);

  const getTargetPaths = () => {
    const basePaths = {
      wishlist: '/buyer/wishlist',
      cart: '/checkout'
    };

    if (role === 'seller') return { 
      ...basePaths,
      messages: '/seller/messages', 
      notifications: '/seller/notifications',
    };
    if (['admin', 'superadmin'].includes(role)) return { 
      ...basePaths,
      messages: '/admin/messages', 
      notifications: '/admin/notifications',
    };
    
    // Default / Buyer / Guest
    return { 
      ...basePaths,
      messages: '/buyer/messages', 
      notifications: '/buyer/notifications',
    };
  };

  const navPaths = getTargetPaths();

  return (
    <div className="mobile-bottom-nav">
      <div className="bottom-nav-item" onClick={() => navigate("/")}>
        <IconRocket size={24} className={location.pathname === "/" ? "active" : ""} />
        <span>Home</span>
      </div>

      <div className="bottom-nav-item" onClick={() => navigate("/categories")}>
        <IconBox size={24} className={location.pathname.includes("categories") ? "active" : ""} />
        <span>Category</span>
      </div>

      <div className="bottom-nav-item" onClick={() => setIsDrawerOpen(true)}>
        <Badge count={cartCount} size="small" offset={[5, -2]}>
          <IconShoppingCart size={24} className={isDrawerOpen ? "active" : ""} />
        </Badge>
        <span>Cart</span>
      </div>

      <div className="bottom-nav-item" onClick={() => navigate(navPaths.wishlist)}>
        <Badge count={wishlistCount} size="small" offset={[5, -2]}>
          <IconHeart size={24} className={location.pathname.includes("wishlist") ? "active" : ""} />
        </Badge>
        <span>Wishlist</span>
      </div>
    </div>
  );
};

export default MobileBottomNav;
